import React, { useCallback, useMemo } from 'react';
import { Modal, Tabs } from 'antd';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import {
  preferredSubdomainCookieName,
  redirectToSubdomain
} from '@components/OrganizationBoundary';
import { useIsDemoOrganization } from '@hooks/useIsDemoOrganization';

import { ReactComponent as CrossSvg } from '@assets/icons/cross.svg';
import { toggleBootcampModal } from '@redux/actions/modalAction';
import { BootcampModalStateProps } from '@redux/types/modalType';

import TabVideo from './components/TabVideo';
import TabInteractiveTour from './components/TabInteractiveTour';

import './BootcampModal.less';

export default function BootcampModal({ visible }: BootcampModalStateProps) {
  const dispatch = useDispatch();
  const isDemoOrganization = useIsDemoOrganization();

  const onCloseModal = useCallback(() => {
    dispatch(toggleBootcampModal({ visible: false }));
    if (isDemoOrganization)
      redirectToSubdomain(
        Cookies.get(preferredSubdomainCookieName) || 'demo-over',
        'campaigns/all'
      );
  }, [dispatch, isDemoOrganization]);

  const tabsItems = useMemo(() => {
    return [
      {
        label: 'Video',
        key: 'video',
        children: <TabVideo />
      },
      {
        label: 'Interactive Tour',
        key: 'interactiveTour',
        children: (
          <TabInteractiveTour
            onCloseModal={() =>
              dispatch(toggleBootcampModal({ visible: false }))
            }
          />
        )
      }
    ];
  }, [dispatch]);

  return (
    <Modal
      open={visible}
      footer={null}
      centered={true}
      width={1032}
      destroyOnClose
      zIndex={999}
      bodyStyle={{ height: 'auto' }}
      onCancel={() => onCloseModal()}
      className={classNames('bootcamp-modal')}
    >
      <CrossSvg className="bootcamp-modal-btn-close" onClick={onCloseModal} />
      <Tabs
        defaultActiveKey="1"
        tabPosition="left"
        items={tabsItems}
        className="bootcamp-modal_tabs"
      />
    </Modal>
  );
}
